<template>
  <div>
    <div v-for="(chunk, index) of chunks" :key="`chunk-${index}`">
      <BaseDynamicLoader
        :identifier="`chunk-${index}`"
        observerElmSelector=".response-body-container"
        :buffer="500"
        :enableInitialMountFadeIn="false"
      >
        <pre class="bg-white fade-in"><code v-html="chunk" /></pre>
      </BaseDynamicLoader>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChunkedJsonRenderer',
  props: {
    chunks: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped>
.fade-in {
  animation: fadeIn 100ms ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>